<template>
  <div class="container container-vende-tu-auto">

    <div v-if="this.domicilio === 'domicilio'" class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center ">

      <img class="step-desktop" src="../assets/imgs/desktop/desktop-VTA-domicilio.png" alt="AUTOCOM" />
      <img class="step-tablet" src="../assets/imgs/tablet/tablet-VTA-VALORACION-DOMICILIO01.png" alt="AUTOCOM" />
      <img class="step-mobile" src="../assets/imgs/mobile/MOBILE-VTA-VALORACION-DOMICILIO.png" alt="AUTOCOM" />
    </div>

    <div v-if="this.domicilio !== 'domicilio'" class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center ">
      <img class="step-desktop" src="../assets/imgs/desktop/desktop-VTA-agencia.png" alt="AUTOCOM" />
      <img class="step-tablet" src="../assets/imgs/tablet/tablet-VTA-VALORACION-AGENCIA02.png" alt="AUTOCOM" />
      <img class="step-mobile" src="../assets/imgs/mobile/MOBILE-VTA-VALORACION-AGENCIA.png" alt="AUTOCOM" />
    </div>

    <div class="container container-info">
      <div class="container-vende-view">

        <div class="content-va ">

          <div class="row margin-agencenciains"
            v-if="this.domicilio !== 'domicilio' && this.GeoLocal === true && this.NoGeoLocal === false">

            <div v-if="this.domicilio !== 'domicilio'" class="text-center marcaModeloAño oferta-infoauto controls">{{
              año }} <span class="black">{{ marca }} {{ modelo }}</span></div>
            <div v-if="this.domicilio !== 'domicilio'" class="mb-5 versionColorKm versionColorKm-aux text-center">{{
              version }} <span class="pipe">|</span> {{ color }} <span class="pipe">|</span> {{ kmComputedString }} KM
            </div>

            <div class="col-xl-3 col-md-6 col-sm-6 col right">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom1">*Estado</h5>
                <select class="form-select select margin-doml" @change="agenciasGeo()" required
                  v-model="localidadSelect">
                  <option selected value=''>
                    Elige una opción
                  </option>
                  <option v-for="localidad in localidades" :key="localidad.estado">
                    {{ localidad.estado }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-6 right">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom-2">*Agencia</h5>
                <input v-if="this.localidadSelect === ''" class="input-f" placeholder="Elige una opción"
                  aria-label="fecha" disabled />
                <select v-if="this.localidadSelect !== ''" class="form-select select margin-doml"
                  @change="asignAgencia()" required v-model="agenciaSelect" style="text-overflow: ellipsis;">
                  <option selected disabled value=''>
                    Elige una opción
                  </option>
                  <option v-for="agencia in agencias" :key="agencia.id">
                    {{ agencia.nombre }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-6 margin--modelo text--left left ">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom3" :class="{textoErrorf: (this.fechaError == false)}">*Fecha</h5>
                <!--input v-if="this.agenciaSelect !== ''" :type="focusInput ? 'date': 'text'" v-model="fechaSelect"
                  placeholder="dd/mm/aaaa" @change="agendaGeo()" class="input-f" :min="getMin()" :max="getMax()"
                  :class="{inputferror: (this.fechaError == false)}" aria-label="fecha" />
                <input v-if="this.agenciaSelect === ''" :type="focusInput ? 'date': 'text'" class="input-f"
                  placeholder="dd/mm/aaaa" aria-label="fecha"  disabled /-->

                  <date-picker v-if="this.agenciaSelect !== ''" @change="agendaGeo()" format="DD-MM-YYYY" v-model="fechaSelected" valueType="format" :disabled-date="getIntervalo" :lang="lang"></date-picker>
                  <!--date-picker v-if="this.agenciaSelect === ''" format="DD-MM-YYYY" v-model="fechaSelected" valueType="format" disabled :lang="lang"></date-picker-->
                  <input v-if="this.agenciaSelect === ''" :type="focusInput ? 'date': 'text'" class="input-f"
                  placeholder="dd/mm/aaaa" aria-label="fecha"  disabled>
                <label class="mensajeError" v-if="this.fechaError == false">Fecha incorrecta</label>
                <label class="mensajeLabel mrg-label"
                  v-if="this.agenciaSelect !== '' && this.fechaSelect === ''">Selecciona una fecha</label>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-6 margin--modelo margin--domh text-center">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom4">*Hora</h5>
                <select v-if="this.horaActive === true" class="form-select select-fh" required v-model="agendaSelect">
                  <option selected disabled value="">
                    Elige un horario
                  </option>
                  <!-- <option selected value="00:00">
                      00:00
                    </option> -->
                  <option v-for="hora in horas" :key="hora.idcalendario" :value="hora.idcalendario">
                    {{ hora.hora }}
                  </option>
                </select>
                <input v-if="this.horaActive === false" placeholder="00:00" type="text" class="select-fh" disabled>
                <label class="mensajeLabel mrg-label2"
                  v-if="this.fechaSelect !== '' && this.agendaSelect === ''">Selecciona un horario</label>
              </div>
            </div>
          </div>

          <div class="row margin-agencenciains"
            v-if="this.domicilio !== 'domicilio' && this.GeoLocal === false && this.NoGeoLocal === true">

            <div v-if="this.domicilio !== 'domicilio'" class="text-center marcaModeloAño oferta-infoauto controls">{{
              año }} <span class="black">{{ marca }} {{ modelo }}</span></div>
            <div v-if="this.domicilio !== 'domicilio'" class="text-center versionColorKm versionColorKm-aux">{{ version
              }} <span class="pipe">|</span> {{ color }} <span class="pipe">|</span> {{ kmComputedString }} KM</div>

            <div class="col-xl-3 col-md-6 col-sm-6 right">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom1">*Estado</h5>
                <select class="form-select select margin-doml" @change="postAgencias()" required
                  v-model="localidadSelect">
                  <option selected value=''>
                    Elige una opción
                  </option>
                  <option v-for="localidad in localidades" :key="localidad.estado">
                    {{ localidad.estado }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-6 right">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom-2">*Agencia</h5>
                <input v-if="this.localidadSelect === ''" class="input-f" placeholder="Elige una opción"
                  aria-label="fecha" disabled />
                <select v-if="this.localidadSelect !== ''" class="form-select select margin-doml"
                  @change="changeToDate()" required v-model="agenciaSelect" style="text-overflow: ellipsis;">
                  <option selected disabled value=''>
                    Elige una opción
                  </option>
                  <option v-for="agencia in agencias" :key="agencia.id"
                    :value="[agencia.id, agencia.nombre, agencia.domicilio ]">
                    {{ agencia.nombre }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-6 margin--modelo text--left left ">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom3" :class="{textoErrorf: (this.fechaError == false)}">*Fecha</h5>
                <!--input v-if="this.agenciaSelect !== ''" :type="focusInput ? 'date': 'text'" v-model="fechaSelect"
                  placeholder="dd/mm/aaaa" @change="consultaragenda()" class="input-f"
                  :class="{inputferror: (this.fechaError == false)}" aria-label="fecha" :min="getMin()" :max="getMax()" /-->
                <date-picker v-if="this.agenciaSelect !== ''" @change="consultaragenda()" format="DD-MM-YYYY" v-model="fechaSelected" valueType="format" :disabled-date="getIntervalo" :lang="lang"></date-picker>
                <input v-if="this.agenciaSelect === ''" :type="focusInput ? 'date': 'text'" class="input-f"
                  placeholder="dd/mm/aaaa" aria-label="fecha" disabled  />
                <label class="mensajeError" v-if="this.fechaError == false">Fecha incorrecta</label>
                <label class="mensajeLabel mrg-label"
                  v-if="this.agenciaSelect !== '' && this.fechaSelect === ''">Selecciona una fecha</label>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-6 margin--modelo margin--domh text-center">
              <div class="mt-4">
                <h5 class="texto-vehiculoDom4">*Hora</h5>
                <select v-if="this.horaActive === true" class="form-select select-fh" required v-model="agendaSelect">
                  <option selected disabled value="">
                    Elije un horario
                  </option>
                  <!-- <option selected value="00:00">
                      00:00
                    </option> -->
                  <option v-for="hora in horas" :key="hora.idcalendario" :value="hora.idcalendario">
                    {{ hora.hora }}
                  </option>
                </select>
                <input v-if="this.horaActive === false" placeholder="00:00" type="text" class="select-fh" disabled>
                <label class="mensajeLabel mrg-label2"
                  v-if="this.fechaSelect !== '' && this.agendaSelect === ''">Selecciona un horario</label>
              </div>
            </div>
          </div>

          <div class="text-center margin-oferta">
            <div v-if="this.domicilio == 'domicilio'" class="marcaModeloAño oferta-infoauto2 mt-5"> {{ año }} <span
                class="black">{{ marca }} {{ modelo }}</span> </div>
            <div v-if="this.domicilio == 'domicilio'" class="versionColorKm versionColorKm-aux">{{ version }} <span
                class="pipe">|</span> {{ color }} <span class="pipe">|</span> {{ kmComputedString }} KM</div>
            <div v-if="this.domicilio == 'domicilio'" class="row domicilio-datos" style="margin-bottom: 5px;">


              <div class="col-md-6 col-sm-12 margin-codigop">
                <h5 class="texto-vehiculoDom" :class="{textoErrorDom: (this.codigoError == false)}">Código postal</h5>
                <input type="text" class="-inputDomicilio margin-doml" @keyup="validaError3()"
                  :class="{inputErrorDom: (this.codigoError == false)}" v-model="codigoPostal" @change="entidades()"
                  placeholder="Código Postal" aria-label="codigopostal" maxlength="5" />
                <label class="mensajeError mrgError" v-if="this.codigoError == false">Código Postal no valido</label>
              </div>
              <div class="col-md-6 col-sm-12 margin-domicilio">
                <h5 class="texto-vehiculoDom2">Estado</h5>
                <input type="text" class="-inputDomicilio margin-domr" v-model="estado" placeholder="Estado"
                  aria-label="estado" disabled />
              </div>
              <div class="col-md-6 col-sm-12 margin-domicilio">
                <h5 class="texto-vehiculoDom">Ciudad</h5>
                <input type="text" class="-inputDomicilio margin-doml" v-model="ciudad" placeholder="Ciudad"
                  aria-label="ciudad" disabled />
              </div>
              <div class="col-md-6 col-sm-12 margin-domicilio" v-if="this.codigoPostal == '' && this.local == true">
                <h5 class="texto-vehiculoDom2">Colonia</h5>
                <img src="../assets/imgs/ico-tooltip.svg" class="imgToolTip-C" @click="openTooltip" alt="" />
                <div class="descripcion-tooltipC d-none">
                  <p class="text-left p-tooltip"> Si tu colonia no aparece en el listado, puedes escribirla diractemte
                    en el campo </p>
                </div>
                <input type="text" class="-inputDomicilio margin-domr" placeholder="Colonia" aria-label="Colonia"
                  disabled />
              </div>
              <div class="col-md-6 col-sm-12 margin-domicilio" v-if="this.codigoPostal != '' && this.local == true">
                <h5 class="texto-colonia">Colonia</h5>
                <input type="text" class="inputColonia -margin-colonia" v-model="colonia"
                  placeholder="Escribe o selecciona la colonia" aria-label="Colonia" />
                <select class="form-select inputDomicilio margin-domr" v-model="colonia">
                  <option selected disabled value="">
                    Selecciona la colonia
                  </option>
                  <option v-for="colonia in colonias" :key="colonia.colonia">
                    {{ colonia.colonia }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 col-sm-12 margin-domicilio" v-if="this.codigoPostal != '' && this.copomex == true">
                <h5 class="texto-vehiculoDom2">Colonia</h5>
                <input type="text" class="-inputColonia margin-colonia" v-model="colonia"
                  placeholder="Escribe o selecciona la colonia" aria-label="Colonia" />
                <select class="form-select inputDomicilio margin-domr" v-model="colonia">
                  <option selected disabled value="">
                    Selecciona la colonia
                  </option>
                  <option v-for="colonia in colonias" :key="colonia">
                    {{ colonia }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-12 margin-domicilio">
                <h5 class="texto-vehiculoDom">Calle</h5>
                <input type="text" class="-inputDomicilio margin-doml" v-model="calle" placeholder="Calle"
                  aria-label="calle" />
              </div>
              <div class="col-md-6 col-sm-12 margin-domicilio">
                <h5 class="texto-vehiculoDom2">No Exterior</h5>
                <input type="text" class="-inputDomicilio margin-domr" v-model="noExterior" placeholder="No Exterior"
                  aria-label="noExterior" />
              </div>
              <div class="col-md-6 col-sm-12 margin-domicilio">
                <h5 class="texto-vehiculoDom">No Interior</h5>
                <input type="text" class="-inputDomicilio margin-doml" v-model="noInterior" placeholder="No Interior"
                  aria-label="noInterior" />
              </div>

            </div>

            <div v-if="this.domicilio == 'domicilio'" class="row controls">

              <div class="col-md-6 col-sm-12 order-md-2 left">
                <button class="-btn-continue btn-a-domicilio" style="" disabled v-if="!agendaDomicilioBool">
                  CONFIRMAR SOLICITUD
                </button>
                <button class="-btn-continuar btn-a-domicilio" style="" @click.prevent="agendar()" v-else>
                  CONFIRMAR SOLICITUD
                </button>
              </div>

              <div class="col-md-6 col-sm-12 order-md-1 right right-aux">
                <button type="button" style="margin-left: -5px;" @click.prevent="cancelar()"
                  class="button-secondary -btn-cancelE btn-a-domicilio">
                  CANCELA LA SOLICITUD
                </button>
              </div>
            </div>

            <div v-if="this.domicilio !== 'domicilio'" class="row controls-2" style="">


              <div class="col-md-6 col-sm-12 order-md-2 left margin-btn-continua-">
                <button class="-btn-continue btn-a-domicilio" style="" disabled
                  v-if="this.agenciaSelect == '' && this.fechaSelect == '' && this.agendaSelect == '' || this.agenciaSelect !== '' && this.fechaSelect == '' && this.agendaSelect == '' || this.agenciaSelect !== '' && this.fechaSelect !== '' && this.agendaSelect == '' ||
                    this.agenciaSelect == '' && this.fechaSelect == '' && this.agendaSelect == 'nuevaHora' || this.agenciaSelect !== '' && this.fechaSelect == '' && this.agendaSelect == 'nuevaHora' || this.agenciaSelect !== '' && this.fechaSelect !== '' && this.agendaSelect == 'nuevaHora'">
                  AGENDAR INSPECCIÓN
                </button>
                <button class="-btn-continuar btn-a-domicilio" style="" @click.prevent="agendar()"
                  v-if="this.agenciaSelect !== '' && this.fechaSelect !== '' && this.agendaSelect !== '' && this.agendaSelect !== 'nuevaHora'">
                  AGENDAR INSPECCIÓN
                </button>
              </div>

              <div class="col-md-6 col-sm-12 order-md-1 right right-aux margin-btn-cancel-">
                <button type="button" @click.prevent="cancelar()" class="button-secondary -btn-cancelE btn-a-domicilio">
                  CANCELA LA SOLICITUD
                </button>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>


    <b-modal v-model="modalCancelacion" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">
        <div class="col-sm-12 text-center">

          <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />
          <div class="modal-title mt-0">Rechazo de la oferta</div>
          <div class="lament">
            Selecciona el motivo<br />del rechazo de la oferta
          </div>

          <!--div class="mt-4">
            <h5 class="label-folio-3">Cuasa de rechazo</h5>
            <select class="form-select select margin-doml" @change="getMotivos()" required v-model="rechazo"
              style="text-overflow: ellipsis;">
              <option selected disabled value=''>
                Elige una opción
              </option>
              <option v-for="item in rechazos" :key="item.id" :value="[item.id]">
                {{ item.descripcion }}
              </option>
            </select>
          </div-->

          <div class="mt-4">
            <h5 class="label-folio-4">Motivo de rechazo</h5>
            <select class="form-select select margin-doml" required v-model="motivo" style="text-overflow: ellipsis;">
              <option selected disabled value=''>
                Elige una opción
              </option>
              <option v-for="item in motivos" :key="item.id_motivo" :value="[item.id_motivo]">
                {{ item.motivo }}
              </option>
            </select>
          </div>

        </div>
        <div class="controls row">

          <div class="col-md-6 col-sm-12  order-md-2 right">
            <button v-if="this.motivo === ''" disabled class="btn-oferta-rojo -btn-continuar continue">
              RECHAZAR
            </button>
            <button v-if="this.motivo !== ''" class="btn-oferta-rojo -btn-continuar continue"
              @click.prevent="cancelarSolicitud()">
              RECHAZAR
            </button>
          </div>
          <div class="col-md-6 col-sm-12  order-md-1 left">
            <button class="btn-oferta-negro -btn-continuar continue" @click.prevent="cerrarCancelar()">
              CERRAR
            </button>
          </div>

        </div>
      </b-row>
    </b-modal>

    <b-modal v-model="modalErrorConexion" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">

        <div class="col-sm-12 text-center">


          <img class="ico-inspeccion mt-5" src="../assets/imgs/error_varios_icon.svg" alt="AUTOCOM" />

          <div class="modal-title mt-2">ERROR EN NUESTRO SISTEMA</div>

          <div class="lamentamos-2 mt-3">
            Nuestro servicio está presentando errores, por el<br> momento no es posible realizar la operación, inténtalo
            <br> más tarde. <br> <span class="msnError">{{this.mensajeError1}}</span>
          </div>
        </div>

        <div class="text-center mt-4">
          <div class="controls">
            <button class="" @click.prevent="cerrarModal()">
              CERRAR
            </button>
          </div>
        </div>
      </b-row>
    </b-modal>

    <b-modal v-if="this.domicilio !== 'domicilio'" v-model="modalUbicacion" size="lg" style="width: 100%" hide-header
      hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">

        <div class="col-sm-12 text-center">
          <img class="ico-inspeccion mt-5" src="../assets/imgs/ico_locator_gris.svg" alt="AUTOCOM" />
          <div class="modal-title mt-2">SUGERENCIA</div>
          <div class="lamentamos-2 mt-3">
            Al habilitar la ubicación de tu dispositivo podremos recomendar la agencia más cercana.
          </div>
        </div>

        <div class="text-center mt-1">
          <div class="controls">
            <button class="" @click.prevent="cerrarModalUbi()">
              CONTINUAR
            </button>
          </div>
        </div>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: "Evaluacion",

  components: { DatePicker },

  data() {
    return {

      //  server: 'https://srv-autocheck.autocomseminuevos.com/api',

      
      /*server: 'https://api-autocheck.autocom.mx/api',
      serverComunicaciones: 'https://comunicaciones.autocom.mx/api',
      serverUbicaciones: 'https://ubicacion.autocom.mx/api',
      creatioService: 'https://creatioservice.autocom.mx/api',
      twillioservice: 'https://hld3b9zbfd.execute-api.us-east-1.amazonaws.com/apitwilio',
      iframe: 'vendetuauto.autocomseminuevos.com',
      serverNotificaciones: 'https://srv-notificaciones.autocom.mx/api',*/
      

      //server: 'https://dev-srv-valoraciones.autocom.mx/api',


      server: process.env.VUE_APP_SERVER_AUTOCHECK,
      serverComunicaciones: process.env.VUE_APP_SERVER_COMUNICACIONES,
      serverUbicaciones: process.env.VUE_APP_SERVER_UBICACIONES,
      creatioService: process.env.VUE_APP_CREATIO_SERVICE,
      twillioservice: process.env.VUE_APP_TWILIO_SERVICE,
      iframe: process.env.VUE_APP_IFRAME,
      serverNotificaciones: process.env.VUE_APP_SERVER_NOTIFICACIONES,


      marca: sessionStorage.getItem("marca"),
      modelo: sessionStorage.getItem("modelo"),
      año: sessionStorage.getItem("anio"),
      version: sessionStorage.getItem("version"),
      color: sessionStorage.getItem("color"),
      kilometraje: sessionStorage.getItem("kilometraje"),

      domicilio: sessionStorage.getItem("tipoInspeccion"),
      folio: sessionStorage.getItem("folio"),
      modalTipoV: false,
      modalCancelacion: false,
      modalErrorConexion: false,
      mensajeError1: "",
      modalUbicacion: false,
      local: true,
      copomex: false,
      fechaVisual: true,
      horaVisual: false,
      codigoPostal: "",
      ciudad: "",
      estado: "",
      colonia: "",
      colonias: [],
      calle: "",
      noExterior: "",
      noInterior: "",
      agencia: "",
      agencias: [],
      localidad: "",
      localidades: [],
      hora: "",
      horas: [],
      agenciaSelect: "",
      fechaSelect: "",
      fechaSelected: "",
      fechaError: true,
      horaActive: false,
      agendaSelect: "",
      localidadSelect: "",
      agendaDomicilioBool: false,

      nombre: sessionStorage.getItem("nombre"),
      apellidos: sessionStorage.getItem("apellidos"),
      email: sessionStorage.getItem("email"),
      version: sessionStorage.getItem("version"),
      kilometers: sessionStorage.getItem("kilometraje"),
      precio_sugerido: sessionStorage.getItem("precioSolicitado"),
      mobile: sessionStorage.getItem("telefono"),
      offer: sessionStorage.getItem("oferta"),
      offer_day: sessionStorage.getItem("offer_day"),
      offer_consignment: sessionStorage.getItem("offer_consignment"),
      idvaloration: sessionStorage.getItem("idvaloration"),
      idfolioMail: sessionStorage.getItem("idvaloration"),
      validezVA: sessionStorage.getItem("fecha_validez"),
      seguimiento: sessionStorage.getItem("seguimiento"),
      oferta: '',
      ofertaMin: "",
      ofertaMax: "",
      horaValuacion: '',
      fechaValuacion: '',
      sucurcalValuacion: '',
      direccioinAgencia: '',
      lugar: '',
      direccion: '',
      dealerCreatio: '',
      codigoError: true,
      focusInput:false,

      bpmcsrf: '',
      ValCookie: '',

      GeoLocal: false,
      NoGeoLocal: true,

      estadoGeo: '',
      ciudadGeo: '',
      localGeo: '',

      domicilioAgencia: '',
      nombreAgencia: '',
      idAgencia: '',

      idagenciaGeo: '',
      nombreGeo: '',
      domicilioGeo: '',
      latitud: '',
      longitud: '',

      fullagencias: [],
      rechazos: [],
      rechazo: '',
      motivos: [],
      motivo: '',
      token:'',
      expediente:'',
      time: null,

      lang: {
        formatLocale: {
            // MMMM
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            // MMM
            monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            // dddd
            weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            // ddd
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
            // dd
            weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
          },
        },
      };
  },

  methods: {
    getIntervalo(date) {
      const today=new Date();
      today.setDate(today.getDate()+1)
      //const today = new Date();
      today.setHours(0, 0, 0, 0);

      //return date < today || date > new Date(today.getTime() + 4 * 24 * 3600 * 1000) || date.getDay()===0;
      return date < today || date > new Date(today.getTime() + 4 * 24 * 3600 * 1000);
    },

    crearExpediente(param) {

      let body={
          "email": sessionStorage.getItem("email"),
          "phone": sessionStorage.getItem("telefono"),
          "scheduling_date": sessionStorage.getItem("fechaAgenda"),
          "scheduling_time": sessionStorage.getItem("horaAgenda"),
          "content": {
              "Cliente": sessionStorage.getItem('nombre'),
              "Make": sessionStorage.getItem("marca"),
              "Model": sessionStorage.getItem("modelo"),
              "Year": sessionStorage.getItem("anio"),
              "Color": sessionStorage.getItem("color"),
              "Milage": sessionStorage.getItem("kilometraje"),
              "Version": sessionStorage.getItem("version"),
              "Folio_Gestor_Precios": sessionStorage.getItem("folio"),
              "Folio_Autocheck": sessionStorage.getItem("idvaloration")
            }
      }

      axios.post(this.server + "/valuacion/crea_expediente", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {

        console.log("Respuesta -->", JSON.stringify(response.data.data));

        sessionStorage.setItem('expediente', response.data.data[0].expediente_uuid);
        sessionStorage.setItem('tokenExpediente', response.data.data[0].expediente_token);

        this.token=response.data.data[0].expediente_token;
        this.expediente=response.data.data[0].expediente_uuid
        if(param===''){
          this.mailAgencia();   
        }else{
          this.mailDomicilio();
        }

      })
      .catch((error) => {
        
      });
    },

    changeToText(){
      this.focusInput = false;
    },

    changeToDate(){
      /*this.focusInput = true;
      this.fechaSelect = '';
      this.horaActive = false;
      this.agendaSelect = '';*/

      this.focusInput = true;
      let min=this.getMin();
      let _split=min.split('-');
      this.fechaSelected=_split[2]+'-'+_split[1]+'-'+_split[0];
      this.fechaSelect = this.getMin();
      this.consultaragenda();
      this.horaActive = true
    },

    openTooltip(){
      const tooltip = document.querySelector('.descripcion-tooltipC')
      tooltip.classList.toggle('d-none')
    },

    cerrarModal(){
      clearInterval(this.intervalos);
      this.modalErrorConexion = false;

    },

    cerrarModalUbi(){
      this.modalUbicacion = false;
    },

    cargarToken() {
      let user = { usuario: "AutocomGeo", password: "Ub1c4c10n35" };
      axios
        .post(this.serverUbicaciones + "/auth", user)
        .then((response) => {
          sessionStorage.setItem("tokenUbicacion", response.data.token);
          this.vigenciaOferta();
        })
        .catch((error) => {
          // this.modalErrorConexion = true;
          // this.mensajeError = 'EUTKN';
          this.snifferError(error.message, 'ubicaciones');
          console.log('Existe un error en ubicaciones ...', error.message);
        });
    },

    cargarTokenMail() {
      let user = { username: "vendetuauto@autocom.mx", password: "Desarrollo123$" };
      axios.post(this.serverNotificaciones + "/token/login", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenMensaje", response.data.token);
        }).catch((error) => {
          // this.mensajeError = 'ENTKN';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'notificaciones');
          console.log('Existe un error en notificaciones ...', error.message);
        });
    },

    /*tokenCreatio() {
      let user = { usuario: "CreatioService", password: "Cr34t1053rv1c3" };
      axios.post(this.creatioService + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenCreatio", response.data.token);
        }).catch((error) => {
          // this.mensajeError = 'ECTKN';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
        });
    },*/

    tokenComunicaciones() {
      let user = { usuario: "Comunicaciones", password: "C0mun1c4c10n35" };
      axios.post(this.serverComunicaciones + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenComunicacion", response.data.token);
        }).catch((error) => {
          this.mensajeError1 = 'ECOTK';
          this.modalErrorConexion = true;
          console.log('Error en el servicio de comunicaciones ...', error.message)
        });
    },

    snifferError(error, servicio) {

      let data = {
        error: error,
        servicio: servicio,
      }


      axios.post(this.serverComunicaciones + "/snifferVa", data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          console.log('Alerta enviada');
        })
        .catch((error) => {
          console.log('Error de alerta --->', error);
        });

    },

    getEstados() {
      axios
        .get( this.server + "/calendario/lista_estados", {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {

          this.localidades = response.data.data;
          //console.log('Localidades ---> ',this.localidades)
        })
        .catch((error) => {
          this.modalErrorConexion = true;
          this.mensajeError = 'EACCE';
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });
    },
    postAgencias(){

      console.log('agencias -->',this.localidadSelect);

      this.agenciaSelect = '';
      this.agendaSelect = '';
      this.horaActive = false;
      this.fechaSelect = '';
      this.fechaSelected = '';

      let body = {
        estado: this.localidadSelect,
      };

      axios
        .post( this.server + "/calendario/sucursales_estado", body, {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {

          this.agencias = response.data.data;
          //console.log('Agencias -->',this.agencias)

        })
        .catch((error) => {
          this.modalErrorConexion = true;
          this.mensajeError = 'EACCA';
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });      
    },

    getAgencias() {
      axios
        .get( this.server + "/calendario/sucursales", {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {

          this.agencias = response.data.data;
          //console.log(this.agencias)
        })
        .catch((error) => {
          this.modalErrorConexion = true;
          this.mensajeError = 'EACCA2';
            this.snifferError(error.message,'valoraciones');
            console.log('Existe un error en valoraciones ...',error.message);
        });
    },

    agendar() {

      if (this.domicilio == 'domicilio') {

        this.tipoAgendamiento();

      } else {
        if (this.GeoLocal === true || this.NoGeoLocal === false) {

          this.domicilioAgencia = this.domicilioGeo;
          this.nombreAgencia = this.nombreGeo;
          this.idAgencia = this.idagenciaGeo;
          this.tipoAgendamiento();

        } else {

          this.domicilioAgencia = this.agenciaSelect[2];
          this.nombreAgencia = this.agenciaSelect[1];
          this.idAgencia = this.agenciaSelect[0];
          this.tipoAgendamiento();

        }
      }
      
    },

    tipoAgendamiento(){
      console.log('Comenzando -->',this.domicilio);

      if (this.domicilio == 'domicilio'){
        this.lugar = "a domicilio";
        this.direccion = this.calle+' '+this.noExterior+' '+this.noInterior+', '+this.colonia+', '+this.ciudad+', '+this.estado+' CP:'+this.codigoPostal;
        this.dealerCreatio = "Domicilio personal";
        this.horaValuacion = this.agendaSelect;
        this.fechaValuacion = this.fechaSelect;
        sessionStorage.setItem("fechaAgenda", this.fechaValuacion);
        sessionStorage.setItem("horaAgenda", this.horaValuacion);
        sessionStorage.setItem("sucursalAgenda", this.dealerCreatio);
        sessionStorage.setItem("direccionAgencia", this.direccion);
        this.altadomicilio();
      } else {
        this.lugar = "en agencia";
        this.direccion = this.domicilioAgencia;
        this.dealerCreatio = this.nombreAgencia;
        sessionStorage.setItem("idAgencia", this.idAgencia);
        sessionStorage.setItem("direccionAgencia", this.direccion);
        this.generarCita();
      }
    },
    consultaragenda() {

      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      let _split=this.fechaSelected.split('-');
      this.fechaSelect=_split[2]+'-'+_split[1]+'-'+_split[0];

      if (this.fechaSelect >= output) {
        this.fechaError = true;
        this.horaActive = true;

        let _id=this.agenciaSelect[0];
        if(isNaN(this.agenciaSelect[0])){
          _id=this.idagenciaGeo;
        }

        let body = {
          fechaInicial: this.fechaSelect,
          fechaFinal: this.fechaSelect,
          idcalendario: 0,
          idsucursal: _id,
          idcliente: 0,
          idpmrg: 0,
          idcomprador: 0
        };

        //console.log('Datos -->',body);

        axios.post(this.server + "/calendario/consulta", body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          /*console.log("Respuesta 2 -->", Number(this.agenciaSelect[0])===57);
          if(Number(_id)===57){ //Pedregal
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=18 && _hora!==15 && _hora!==16){
                    return hora;
                  }
                }
                
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(_id)===58){ //Honda Universidad
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=17 && _hora!==15 && _hora!==16){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(_id)===59){ //Hyundai Universidad
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===1 || _date.getDay()===3 || _date.getDay()===5){//Lunes, miércoles y viernes
                  if(_hora>=15 && _hora<=17){
                    return hora;
                  }
                }else if(_date.getDay()===2 || _date.getDay()===4 || _date.getDay()===6){//martes, jueves y sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(_id)===60){ //Toyota Universidad
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                console.log()
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=12){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=17 && _hora!==14 && _hora!==15){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(_id)===61 ){ //Toyota revolucion
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=12){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=17){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(_id)===62 || Number(_id)===63){ //Autocom Patriotismo, Autocom Revolucion
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=18 && _hora!==14 && _hora!==15){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else{*/
            this.horas = response.data.data;
            this.horaVisual = true;
            this.fechaVisual = false;
          //}
        })
        .catch((error) => {
          this.modalErrorConexion = true;
          this.mensajeError = 'EACCAL';
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
        });
      } else {
        this.fechaError = false;
        this.horaActive = false;
      }
      },

    getMin(){
      const today=new Date();
      today.setDate(today.getDate()+1)
      let month=today.getMonth()+1;
      let day=today.getDate();

      if (day < 10) {
        day = '0' + day;
      }

      if (month < 10) {
          month = `0${month}`;
      }
      return `${today.getFullYear()}-${month}-${day}`;
    },


    getMax(){
      const today=new Date();
      today.setDate(today.getDate()+5)

      let month=today.getMonth()+1;
      let day=today.getDate();

      if (day < 10) {
        day = '0' + day;
      }

      if (month < 10) {
          month = `0${month}`;
      }

      return `${today.getFullYear()}-${month}-${day}`;
    },

    validaFecha(){
      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');

      if (this.fechaSelect >= output) {
        this.fechaError = true;
        this.horaActive = true;
      } else {
        this.fechaError = false;
        this.horaActive = false;
      }
    },

    generarCita() {
      console.log('Generar cita');
      let body = {
        fechaInicial: this.fechaSelect,
        fechaFinal: this.fechaSelect,
        idcalendario: this.agendaSelect,
        idsucursal: this.idAgencia,
        idcliente: sessionStorage.getItem("idcliente"),
        idpmrg: 0,
        idcomprador: 0,
        idvaloracion: sessionStorage.getItem("idvaloration")
      };

      //console.log('Json Para generar Cita -->',body);

      axios.put(this.server + "/calendario/generar_cita", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        //console.log("Respuesta Generar Cita -->", response);
        this.fechaValuacion = response.data.data[0].fecha_calendario_legible;
        sessionStorage.setItem("fechaAgenda", this.fechaValuacion);
        this.horaValuacion = response.data.data[0].hora.substring(0,5);
        sessionStorage.setItem("horaAgenda", this.horaValuacion);
        sessionStorage.setItem("sucursalAgenda", this.nombreAgencia);
        sessionStorage.setItem("idAgenda", response.data.data[0].id);
        
        this.actualizaSucursal();
      
      })
      .catch((error) => {
        this.modalErrorConexion = true;
          this.mensajeError = 'EACGC';
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
      });
    },

    actualizaSucursal() {
      console.log('Actualiza Sucursal');
      let body = {
        id: this.idvaloration,
        rid_sucursal: this.idAgencia
      };

      //console.log('Json actualiza sucursal -->',body);

      axios.post(this.server + "/valuacion/update_sucursal", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          //console.log("Respuesta Actualiza Sucural -->", response.data);
          this.asignaSucursal();
        })
        .catch((error) => {
          this.modalErrorConexion = true;
          this.mensajeError = 'EVAACS';
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });
    },

    asignaSucursal() {
      console.log("Asignar sucursal -->",this.idvaloration+' - '+this.idAgencia);
      let body = {
        "id": this.idvaloration,
        "rid_sucursal_contratos": this.idAgencia
      };

      axios.post(this.server + "/valuacion/update_sucursalContratos", body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
          .then((response) => {
            //console.log("Respuesta Asigna Surcual  -->", response.data);
            //console.log('Domicilio -->',this.domicilio);
            sessionStorage.setItem("tipoAgendamiento", 'agendamiento');
            //this.mailCreatio();

            if (this.seguimiento === 'creatio') {  
              console.log('creatio ');            
              //this.keysCreatio();
              this.CreatioLeads();
              this.crearExpediente('');    
              //this.mailAgencia();
            } else {
              console.log('atendido por asesor');
              this.crearExpediente('');    
               //this.mailAgencia();
            }
          })
          .catch((error) => {
            this.modalErrorConexion = true;
            this.mensajeError = 'EVAAS';
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
          });
    },

    altadomicilio() {
      console.log("Domicilio");
      let body = {
        id: sessionStorage.getItem("idcliente"),
        calle: this.calle,
        num_ext: this.noExterior,
        num_int: this.noInterior,
        codigo_postal: this.codigoPostal,
        colonia: this.colonia,
        ciudad: this.ciudad,
        estado: this.estado,
        folio: sessionStorage.getItem("idvaloration")
      };

      //console.log('Body -->',body);

      axios.post(this.server + "/cliente_domicilio/create", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          //this.mailCreatio();
          sessionStorage.setItem("tipoAgendamiento", 'agendamiento');
          if (this.seguimiento === 'creatio') {
            console.log('creatio');
            //this.keysCreatio();
            this.CreatioLeads();
            this.crearExpediente('domicilio');
            //this.mailDomicilio();
          } else {
            console.log('atendido por un asesor');
            this.crearExpediente('domicilio');
            //this.mailDomicilio();
          }
        })
        .catch((error) => {
          this.modalErrorConexion = true;
          this.mensajeError = 'EVADOM';
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });
    },

    cancelar() {
      this.modalCancelacion = true;
    },

    cerrar() {
      this.modalTipoV = false;
    },

    cerrarCancelar() {
      this.modalCancelacion = false;
    },

    cancelarSolicitud() {
      this.modalCancelacion = false;
      setTimeout(() => {
        window.location.replace('/');
      }, 150);
      // window.history.go(-3);
    },

    vigenciaOferta() {

      console.log('Valida agendamiento');

      let body = { folio: sessionStorage.getItem("idvaloration"),
            telefono: ''
            };

      //console.log(body);

      axios.post(
          this.server + "/calendario/valoracion_agendamiento",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          const date = new Date();
          // const output = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
          const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
            const dia = new Date(output).getTime();
            const diac = Math.round(dia/(1000*60*60*24));

          this.diaActual = output;
          this.diaVigencia = response.data.data[0].vigencia_oferta.substring(0,2);
          this.mesVigencia = response.data.data[0].vigencia_oferta.substring(3,5);
          this.anioVigencia = response.data.data[0].vigencia_oferta.substring(6,10);
          this.fechaVigencia = this.anioVigencia+'-'+this.mesVigencia+'-'+this.diaVigencia;
          const dia2 = new Date(this.fechaVigencia).getTime();
          const diac2 = Math.round(dia2/(1000*60*60*24));

          console.log('Días -->',diac+' - '+diac2);

          if (diac > diac2) {

            //window.location.replace('/Oferta');
            console.log('oferta no valida');

            } else {

              console.log('Oferta Vigente');

            }
        })
        .catch((error) => {
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.modalErrorConexion = true;
          this.mensajeError = 'EVAVVF';
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });
    },

    validaError3(){
      if(this.codigoPostal.length > 1){
        this.codigoError = true;
      }
    },

    entidades() {

      if(this.codigoPostal.length !== 5){
        this.codigoError = false;
      } else 
      if (this.codigoPostal === '') { 
        this.colonia = '';
        this.ciudad = '';
        this.estado = '';
      } else { 
        this.cp = this.codigoPostal;
        console.log("Accediendo Entidades Autocom ", this.cp);
        axios
          .get(this.serverUbicaciones + "/ubicaciones/" + this.cp,
            {
              headers: {
                Authorization:
                  "Bearer " + sessionStorage.getItem("tokenUbicacion"),
                "Content-Type": "application/json",
              },
            })
          .then((response) => {
            this.status = response.data.status;
            if (this.status == 404) {
              console.log("Accediendo a Entidades COPOMEX");
              this.copomexApi();
            } else {
              this.colonias = response.data;
              this.entidadV = response.data[0].entidad;
              this.estado = this.entidadV;
              this.ciudadV = response.data[0].municipio;
              this.ciudad = this.ciudadV;
            }
          })
          .catch((error) => {
            // this.modalErrorConexion = true;
            // this.mensajeError = 'EUOE';
              this.snifferError(error.message, 'ubicaciones');
              console.log('Existe un error en ubicaciones ...', error.message);
              //if (this.status == 404) {
              console.log("Accediendo a Entidades COPOMEX");
              this.copomexApi();
              //}
          });
      }
    },
    copomexApi() {
      const apiKey = "d4c02750-5501-4edf-a41c-74de91ba84c8";
      this.cp = this.codigoPostal;
      axios
        .get(
          "https://api.copomex.com/query/info_cp_geocoding/" +
          this.cp +
          "?type=simplified&token=" +
          apiKey
        )
        .then((response) => {
          this.colonias = response.data;
          this.entidadV = response.data.response.estado;
          this.estado = this.entidadV;
          this.ciudadV = response.data.response.municipio;
          this.ciudad = this.ciudadV;
          this.guardaAPI(response);
        })
        .catch((error) => {
          if(error.response.data.error_message === "No se encontró el cp"){
            this.codigoError = false;
          } else {
            // this.modalErrorConexion = true;
            // this.mensajeError = 'EUOEX';
            this.snifferError(error.message, 'copomex');
            console.log('Existe un error en copomex ...', error.message);
          }

        });
    },

    async guardaAPI(response) {
      console.log("Guardar Datos");
      const nuevosDatos = {
        codigopostal: response.data.response.cp,
        entidad: response.data.response.estado,
        ciudad: response.data.response.ciudad,
        municipio: response.data.response.municipio,
        colonia: [...response.data.response.asentamiento],
      };
      for (let i = 0; i < nuevosDatos.colonia.length; i++) {

        const nuevoCP = {
          codigopostal: nuevosDatos.codigopostal,
          entidad: nuevosDatos.entidad,
          ciudad: nuevosDatos.ciudad,
          municipio: nuevosDatos.municipio,
          colonia: nuevosDatos.colonia[i],
        };
        this.agregar(nuevoCP);
      }
    },

    agregar(nuevoCP) {

      axios
        .post(this.serverUbicaciones + "/ubicaciones/add", nuevoCP,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenUbicacion"),
              "Content-Type": "application/json",
            },
          })
        .then((response) => {
          this.result = response.status;
          if(this.result == 200){
            this.entidades();
          }
        })
        .catch((error) => {
          // this.modalErrorConexion = true;
          //   this.mensajeError = 'EUAE';
          this.snifferError(error.message, 'ubicaciones');
          console.log('Existe un error en ubicaciones ...', error.message);
        });
    },
    checkFormDomicilio() {
       if (this.codigoPostal !== '' && this.estado !== '' && this.ciudad !== '' && this.colonia !== '' && this.calle !== '' && this.noExterior !== '') {
         this.agendaDomicilioBool = true;
       } else {
         this.agendaDomicilioBool = false;
       }
     },

    dateCreatio(){
      const date = new Date();
      const date2 = new Date().toString();
      const date3 = date2.substring(16,24)
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaOriginacion", output);
      sessionStorage.setItem("fechaCreatio", output+'T'+date3+'-00:00');
    },

    /*keysCreatio(){

      console.log('Creando token creatio');

      let user = {
        usuario:"AutocomITConnector",
        contrasenia: "raFA89Hx2JCUkJA6GN#$NL"
      }

      axios.post(this.creatioService + '/creatioToken', user, 
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenCreatio"),
            "Content-Type": "application/json",
          },
        })
      .then(response =>{
        this.bpmcsrf = response.data.BPMCSRF;
        this.ValCookie = response.data.CookieVal;
        this.CreatioLeads();
      }).catch(error=>{
        // this.modalErrorConexion = true;
        // this.mensajeError = 'EUAE';
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
      });

    },*/

    CreatioLeads(){

      console.log('Modificando lead');

      let data = {
        id: sessionStorage.getItem("IdCreatio"),
        nombre: sessionStorage.getItem("nombre"),
        nombreContacto: sessionStorage.getItem("nombre") +' '+ sessionStorage.getItem("apellidos"),
        telefono: sessionStorage.getItem("telefono"),
        mail: sessionStorage.getItem("email"),
        necesidad: "Toma",
        proveedor: "DealerOn",
        fuente: "www.seminuevos.com",
        aplicacion: "Vende Tu Auto",
        marca: sessionStorage.getItem("marca"),
        modelo: sessionStorage.getItem("modelo"),
        anio: sessionStorage.getItem("anio"),
        version: sessionStorage.getItem("version"),
        kms: sessionStorage.getItem("kilometraje"),
        costo: sessionStorage.getItem("precioSolicitado"),
        Oferta: this.offer,
        OfertaConsignacion: this.offer_consignment,
        OfertadelDia: this.offer_day,
        TipoValuacion: this.domicilio,
        AgenciaValuacion: this.dealerCreatio,
        FolioValuacion: sessionStorage.getItem("idvaloration"),
        FechaCitaValuacion: this.fechaValuacion,
        HoraCitaValuacion: this.horaValuacion,
        Calle: this.calle,
        Ciudad: this.ciudad,
        Estado: this.estado,
        CP: this.codigoPostal,
        Colonia: this.colonia,
        NumExt: this.noExterior,
        NumInt: this.noInterior,
        color: sessionStorage.getItem("color"),
        precioDeseado: sessionStorage.getItem("precioSolicitado"),
        /*BPMCSRF: this.bpmcsrf,
        cookie: this.ValCookie*/
      }

      //console.log('JSON Data 2 -->', data);
      //Authorization:"Bearer " + sessionStorage.getItem("tokenCreatio"),

      axios.put(this.creatioService + `/leads/${sessionStorage.getItem("IdCreatio")}/autocom_creatio`, data, 
        {
          headers: {
            "Content-Type": "application/json",
          },
        })
      .then(response =>{
        //console.log(response.data.info);
        //this.AgregandoLeads();
      }).catch(error=>{
        // this.mensajeError = 'ECML';
        // this.modalErrorConexion = true;
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
      });

    } ,

    /* AgregandoLeads(){

      console.log('Update lead creatio');

      let data = {
        idcreatio: sessionStorage.getItem("IdCreatio"),
        estatus: "Oferta Final"
      }

      axios.put(this.creatioService + '/updateLead', data, 
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenCreatio"),
            "Content-Type": "application/json",
          },
        })
      .then(response =>{
        console.log('Lead Final');
      }).catch(error=>{
        // this.mensajeError = 'ECMLDB';
        // this.modalErrorConexion = true;
          this.snifferError(error.message, 'creatio');
          console.log('Existe un error en creatio ...', error.message);
      });

     },*/

    mailAgencia(){

      this.oferta = this.formatPrice(this.offer);
      this.ofertaMin = sessionStorage.getItem("ofertaMin");
      this.ofertaMax = sessionStorage.getItem("ofertaMax");
      this.foliomail = sessionStorage.getItem("folio");

        let mail = {
            user: "vendetuauto@autocom.mx",
            aplication:"Vende tu Auto",
            subject:"Haz solicitado la inspección "+this.lugar+" de tu vehículo en Autocom",
            EmailsTo: [{email:this.email}],
            EmailsToCc: [{emailCc:""},
            {emailCc:""}],
            body:`
            <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
      <html>
      <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
      <!-- utf-8 works for most cases -->
      <meta name="viewport" content="width=device-width">
      <!-- Forcing initial-scale shouldn't be necessary -->
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <!-- Use the latest (edge) version of IE rendering engine -->
      <title>Codigo verificacion</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
      <!-- The title tag shows in email notifications, like Android 4.4. -->

      <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
      <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

      <!-- CSS Reset -->
      <style type="text/css">
      /* What it does: Remove spaces around the email design added by some email clients. */
            /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
      html, body {
        margin: 0 !important;
        padding: 0 !important;
        height: 100% !important;
        width: 100% !important;
      }
      /* What it does: Stops email clients resizing small text. */
      * {
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
      }
      /* What it does: Forces Outlook.com to display emails full width. */
      .ExternalClass {
        width: 100%;
      }
      /* What is does: Centers email on Android 4.4 */
      div[style*="margin: 16px 0"] {
        margin: 0 !important;
      }
      /* What it does: Stops Outlook from adding extra spacing to tables. */
      table, td {
        mso-table-lspace: 0pt !important;
        mso-table-rspace: 0pt !important;
      }
      /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
      table {
        border-spacing: 0 !important;
        border-collapse: collapse !important;
        table-layout: fixed !important;
        margin: 0 auto !important;
        margin-block-end: 5px;
        margin-block-start: 5px;
      }
      table table table {
        table-layout: auto;
      }
      /* What it does: Uses a better rendering method when resizing images in IE. */
      img {
        -ms-interpolation-mode: bicubic;
      }
      /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
      .yshortcuts a {
        border-bottom: none !important;
      }
      /* What it does: Another work-around for iOS meddling in triggered links. */
      a {
              color: #AF0F2B;
              text-decoration: underline;
              font-weight: 700;
            }

      .cabeza2{
        font-family: Arial,helvetica,sans-serif;
      font-style: italic;
      font-weight: 800;
      font-size: 22px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      }
      .unidad{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 0px;
      text-align: center;
      color: #000000;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .anio{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .folio{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 22px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      }
      .mejor{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      padding-top: 25px;
      padding-bottom: 2px;
      }
      .oferta{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 34px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #AF0F2B;
      }
      .div_naranja{
        background-color: #E63E19; 

      }
      .validez{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      .inspeccion{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 150.1%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      </style>

      <!-- Progressive Enhancements -->
      <style type="text/css">
      /* What it does: Hover styles for buttons */
      .button-td, .button-a {
        transition: all 100ms ease-in;
      }
      .button-td:hover, .button-a:hover {
        background: #A50932 !important;
        border-color: #A50932 !important;
      }

      /* Media Queries */
      @media screen and (max-width: 480px) {
      /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
      .fluid, .fluid-centered {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* And center justify these ones. */
      .fluid-centered {
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* What it does: Forces table cells into full-width rows. */
      .stack-column, .stack-column-center {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        direction: ltr !important;
      }
      /* And center justify these ones. */
      .stack-column-center {
        text-align: center !important;
      }
      /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
      .center-on-narrow {
        text-align: center !important;
        display: block !important;
        margin-left: auto !important;
        margin-right: auto !important;
        float: none !important;
      }
      table.center-on-narrow {
        display: inline-block !important;
      }
      }
      </style>
      </head>
      <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
      <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
        <tr>
          <td><center style="width: 100%;">
              
              <!-- Visually Hidden Preheader Text : BEGIN -->
              <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Se ha programado la inspección de tu vehículo </div>
              <!-- Visually Hidden Preheader Text : END -->
              
              <div style="max-width: 600px;"> 
                <!--[if (gte mso 9)|(IE)]>
                  <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                  <tr>
                  <td>
                  <![endif]--> 
                
                <!-- Email Header : BEGIN -->
                <div style="width:100%">

                  <img style="max-width:100%" src="https://qa-vendetuauto.autocomseminuevos.com/img/mail/head.jpg" alt="" bgcolor="#ffffff">
                 
                </div>

                <!-- Email Header : END --> 
                
                <!-- Email Body : BEGIN -->
                <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 600px;">
                  
                <!-- 1 Column Text : BEGIN -->
                  <tr>
                    <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr>
                          <td style="padding: 30px;padding-bottom:0px; text-align: center;"> 
                           
                           <h1>
                            <span style="font-family:Arial,Helvetica,sans-serif; font-weight: 800; font-size: 34px; line-height: 150%; text-align: center; color: #AF0F2B; padding-bottom: 5px;">¡FELICIDADES ${this.nombre.toUpperCase()}!</span>
                           </h1>
                           <p class="cabeza2"style="font-family:Arial,Helvetica,sans-serif;font-size: 22px;line-height:150%">
                            <span style="color:#696969; font-style: italic;font-weight: 800;line-height: 150%;">Esta es la oferta que Autocom tiene para ti</span>
                            <br>
                            <span class="unidad"style="font-family:Arial,Helvetica,sans-serif;font-size: 28px;color:#000000;line-height:150%"><b><span class="anio"style="color: #696969">${this.año} </span>${this.marca} ${this.modelo} </b></span>
                            <br>
<span class="folio"style="font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969;line-height: 150%;">NO. DE OFERTA: ${this.foliomail}</span>
<br>
<span class="folio"style="font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969;line-height: 150%;">NO. DE INSPECCIÓN AGENDADA: ${sessionStorage.getItem("idvaloration")}</span>
                           </p>
                          

                            
                           
                            <p class="mejor" style="margin-block-end: 0px;font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969">EL RANGO DE TU<BR>MEJOR OFERTA <b><span style="color:#000000">GARANTIZADA</span></b> ES<br>
                              <span class="oferta"style="font-family:Arial,Helvetica,sans-serif; margin-block-start: 5px;margin-block-end:5px;font-size: 34px;color:#AF0F2B;text-align: center">DE <B>$ ${this.formatPrice(this.formatValue(this.ofertaMin))}.00*</B><br>A <B>$ ${this.formatPrice(this.formatValue(this.ofertaMax))}.00*</B></span>
                            <span class="validez" style="text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969"><br>
                              Esta oferta es válida hasta el <b>${sessionStorage.getItem("fecha_validez")}</b><br>
                              *El monto final de la oferta depende de la inspección del vehículo
                            </span>
                          </p>

                            </td>
                            </tr>
                            
                        <tr>
                          <td>
                            
                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion"><b>Y estos son los datos de la inspección <span style="color:#AF0F2B">${this.lugar}</span><br>que has agendado:</b>
                            </p>
                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion">
                              <b>Fecha:</b> ${this.fechaValuacion}<br>
                              <b>Hora:</b> ${this.horaValuacion} hrs.<br>
                              <b>Agencia:</b> ${this.dealerCreatio}<br>
                              <b>Dirección de inspección:</b> ${this.direccion}</b>
                            </p>
                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion"><b>Si quieres modificar o cancelar la inspección <a href="https://${this.iframe}/Reagendamiento?vafolio=${this.idfolioMail}&seguimiento=${this.seguimiento}" style="color: #AF0F2B">haz clic aquí</a></b>
                            </p>

                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion"><b><span style="font-size: 24px; color: #AF0F2B">¡Vende más rápido!</span><br>
Compártenos los documentos que necesitaremos previo a la revisión de tu auto. <a href="https://expediente.autocom.mx?expediente=${this.expediente}&token=${this.token}&src=va" style="color: #AF0F2B">Haz click aquí</a></b>
                            </p>

                            <hr size="1px" color="#D9D9D9" width="90%">
                                  <p class="validez" style="padding-top:20px;padding-bottom:25px;text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969">
                                    Si necesitas ayuda comunicate a: <br><a href="mailto:atenciononline@autocom.mx" style="color:#AF0F2B">atenciononline@autocom.mx</a> o al tel: <a href="tel:8000220015" style="color:#AF0F2B">800 02 20015</a>
                                  </p>
                          </td>
                        </tr>
                      </table></td>
                  </tr>

          
                <!--[if (gte mso 9)|(IE)]>
                  </td>
                  </tr>
                  </table>
                  <![endif]--> 
              </div>
            </center></td>
        </tr>
      </table>
      </body>
      </html>
            `};

        axios.post(this.serverNotificaciones + "/emailSend",mail, {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
            'Content-Type': 'application/json',
          }, 
          }).then((response) => {
              console.log('Mail --->', response.status);
              //window.location.replace("/Inspeccion");
              this.enviaWhats();
              clearTimeout(this.intervalos);
              this.$router.push({ path: "/Inspeccion" });
          }).catch(error => {
            // this.mensajeError = 'ENEM';
            // this.modalErrorConexion = true;
        this.snifferError(error.message, 'notificaciones');
        console.log('Existe un error en notificaciones ...', error.message);
          });
    },

    mailDomicilio(){

    this.oferta = this.formatPrice(this.offer);
    this.ofertaMin = sessionStorage.getItem("ofertaMin");
    this.ofertaMax = sessionStorage.getItem("ofertaMax");
    this.foliomail = sessionStorage.getItem("folio");

      let mail = {
          user: "vendetuauto@autocom.mx",
          aplication:"Vende tu Auto",
          subject:"Haz solicitado la inspección "+this.lugar+" de tu vehículo en Autocom",
          EmailsTo: [{email:this.email}],
          EmailsToCc: [{emailCc:""},
          {emailCc:""}],
          body:`
          <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
      <html>
      <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
      <!-- utf-8 works for most cases -->
      <meta name="viewport" content="width=device-width">
      <!-- Forcing initial-scale shouldn't be necessary -->
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <!-- Use the latest (edge) version of IE rendering engine -->
      <title>Codigo verificacion</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
      <!-- The title tag shows in email notifications, like Android 4.4. -->

      <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
      <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

      <!-- CSS Reset -->
      <style type="text/css">
      /* What it does: Remove spaces around the email design added by some email clients. */
            /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
      html, body {
        margin: 0 !important;
        padding: 0 !important;
        height: 100% !important;
        width: 100% !important;
      }
      /* What it does: Stops email clients resizing small text. */
      * {
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
      }
      /* What it does: Forces Outlook.com to display emails full width. */
      .ExternalClass {
        width: 100%;
      }
      /* What is does: Centers email on Android 4.4 */
      div[style*="margin: 16px 0"] {
        margin: 0 !important;
      }
      /* What it does: Stops Outlook from adding extra spacing to tables. */
      table, td {
        mso-table-lspace: 0pt !important;
        mso-table-rspace: 0pt !important;
      }
      /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
      table {
        border-spacing: 0 !important;
        border-collapse: collapse !important;
        table-layout: fixed !important;
        margin: 0 auto !important;
        margin-block-end: 5px;
        margin-block-start: 5px;
      }
      table table table {
        table-layout: auto;
      }
      /* What it does: Uses a better rendering method when resizing images in IE. */
      img {
        -ms-interpolation-mode: bicubic;
      }
      /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
      .yshortcuts a {
        border-bottom: none !important;
      }
      /* What it does: Another work-around for iOS meddling in triggered links. */
      a {
              color: #AF0F2B;
              text-decoration: underline;
              font-weight: 700;
            }

      .cabeza2{
        font-family: Arial,helvetica,sans-serif;
      font-style: italic;
      font-weight: 800;
      font-size: 22px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      }
      .unidad{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 0px;
      text-align: center;
      color: #000000;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .anio{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .folio{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 22px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      }
      .mejor{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      padding-top: 25px;
      padding-bottom: 2px;
      }
      .oferta{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 34px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #AF0F2B;
      }
      .div_naranja{
        background-color: #E63E19; 

      }
      .validez{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      .inspeccion{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 150.1%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      </style>

      <!-- Progressive Enhancements -->
      <style type="text/css">
      /* What it does: Hover styles for buttons */
      .button-td, .button-a {
        transition: all 100ms ease-in;
      }
      .button-td:hover, .button-a:hover {
        background: #A50932 !important;
        border-color: #A50932 !important;
      }

      /* Media Queries */
      @media screen and (max-width: 480px) {
      /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
      .fluid, .fluid-centered {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* And center justify these ones. */
      .fluid-centered {
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* What it does: Forces table cells into full-width rows. */
      .stack-column, .stack-column-center {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        direction: ltr !important;
      }
      /* And center justify these ones. */
      .stack-column-center {
        text-align: center !important;
      }
      /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
      .center-on-narrow {
        text-align: center !important;
        display: block !important;
        margin-left: auto !important;
        margin-right: auto !important;
        float: none !important;
      }
      table.center-on-narrow {
        display: inline-block !important;
      }
      }
      </style>
      </head>
      <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
      <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
        <tr>
          <td><center style="width: 100%;">
              
              <!-- Visually Hidden Preheader Text : BEGIN -->
              <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Se ha programado la inspección de tu vehículo </div>
              <!-- Visually Hidden Preheader Text : END -->
              
              <div style="max-width: 600px;"> 
                <!--[if (gte mso 9)|(IE)]>
                  <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                  <tr>
                  <td>
                  <![endif]--> 
                
                <!-- Email Header : BEGIN -->
                <div style="width:100%">

                  <img style="max-width:100%" src="https://qa-vendetuauto.autocomseminuevos.com/img/mail/head.jpg" alt="" bgcolor="#ffffff">
                 
                </div>

                <!-- Email Header : END --> 
                
                <!-- Email Body : BEGIN -->
                <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 600px;">
                  
                <!-- 1 Column Text : BEGIN -->
                  <tr>
                    <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr>
                          <td style="padding: 30px;padding-bottom:0px; text-align: center;"> 
                           
                           <h1>
                            <span style="font-family:Arial,Helvetica,sans-serif; font-weight: 800; font-size: 34px; line-height: 150%; text-align: center; color: #AF0F2B; padding-bottom: 5px;">¡FELICIDADES ${this.nombre.toUpperCase()}!</span>
                           </h1>
                           <p class="cabeza2"style="font-family:Arial,Helvetica,sans-serif;font-size: 22px;line-height:150%">
                            <span style="color:#696969; font-style: italic;font-weight: 800;line-height: 150%;">Esta es la oferta que Autocom tiene para ti</span>
                            <br>
                            <span class="unidad"style="font-family:Arial,Helvetica,sans-serif;font-size: 28px;color:#000000;line-height:150%"><b><span class="anio"style="color: #696969">${this.año} </span>${this.marca} ${this.modelo} </b></span>
                            <br>
<span class="folio"style="font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969;line-height: 150%;">NO. FOLIO: ${this.foliomail}</span>
<br>
<span class="folio"style="font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969;line-height: 150%;">NO. DE INSPECCIÓN AGENDADA: ${sessionStorage.getItem("idvaloration")}</span>
                           </p>
                          

                            
                           
                            <p class="mejor" style="margin-block-end: 0px;font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969">EL RANGO DE TU<BR>MEJOR OFERTA <b><span style="color:#000000">GARANTIZADA</span></b> ES<br>
                              <span class="oferta"style="font-family:Arial,Helvetica,sans-serif; margin-block-start: 5px;margin-block-end:5px;font-size: 34px;color:#AF0F2B;text-align: center">DE <B>$ ${this.formatPrice(this.formatValue(this.ofertaMin))}.00*</B><br>A <B>$ ${this.formatPrice(this.formatValue(this.ofertaMax))}.00*</B></span>
                            <span class="validez" style="text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969"><br>
                              Esta oferta es válida hasta el <b>${sessionStorage.getItem("fecha_validez")}</b><br>
                              *El monto final de la oferta depende de la inspección del vehículo
                            </span>
                          </p>

                            </td>
                            </tr>
                            
                        <tr>
                          <td>
                            
                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion"><b>Y estos son los datos de la inspección <span style="color:#AF0F2B">${this.lugar}</span><br>que has agendado:</b>
                            </p>
                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion">
                              <b>Domicilio donde te visitaremos:</b> ${this.direccion}
                              
                            </p>
                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion"><b>Si quieres modificar o cancelar la inspección <a href="https://${this.iframe}/Reagendamiento?vafolio=${this.idfolioMail}&seguimiento=${this.seguimiento}" style="color: #AF0F2B">haz clic aquí</a></b>
                            </p>

                             <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 18px;color: #696969" class="inspeccion"><b><span style="font-size: 24px; color: #AF0F2B">¡Vende más rápido!</span><br>
Compártenos los documentos que necesitaremos previo a la revisión de tu auto. <a href="https://expediente.autocom.mx?expediente=${this.expediente}&token=${this.token}&src=va" style="color: #AF0F2B">Haz click aquí</a></b>
                            </p>

                            <hr size="1px" color="#D9D9D9" width="90%">
                                  <p class="validez" style="padding-top:20px;padding-bottom:25px;text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969">
                                    Si necesitas ayuda comunicate a: <br><a href="mailto:atenciononline@autocom.mx" style="color:#AF0F2B">atenciononline@autocom.mx</a> o al tel: <a href="tel:8000220015" style="color:#AF0F2B">800 02 20015</a>
                                  </p>

                          </td>
                        </tr>
                      </table></td>
                  </tr>

          
                <!--[if (gte mso 9)|(IE)]>
                  </td>
                  </tr>
                  </table>
                  <![endif]--> 
              </div>
            </center></td>
        </tr>
      </table>
      </body>
      </html>
          `};

      axios.post(this.serverNotificaciones + "/emailSend",mail, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
          'Content-Type': 'application/json',
        }, 
        }).then((response) => {
            console.log('Mail --->', response.status);
            this.mailDomInfo();
            clearTimeout(this.intervalos);
            this.$router.push({ path: "/Inspeccion" });
              //this.enviaWhats();
        }).catch(error => {
          // this.mensajeError = 'ENEMD';
          //   this.modalErrorConexion = true;
        this.snifferError(error.message, 'notificaciones');
        console.log('Existe un error en notificaciones ...', error.message);
        });
    },

    mailDomInfo(){

      this.foliomail = sessionStorage.getItem("folio");

      let mail = {
          user: "vendetuauto@autocom.mx",
          aplication:"Vende tu Auto",
          subject:"Se ha solicitado la inspección a domicilio "+this.foliomail,
          EmailsTo: [{email:"alicia.perez@autocom.mx"}],
          EmailsToCc: [{emailCc:""},
          {emailCc:""}],
          body:`
           <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
            <html>
            <head>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <!-- utf-8 works for most cases -->
            <meta name="viewport" content="width=device-width">
            <!-- Forcing initial-scale shouldn't be necessary -->
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <!-- Use the latest (edge) version of IE rendering engine -->
            <title>Codigo verificacion</title>
              <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
            <!-- The title tag shows in email notifications, like Android 4.4. -->

            <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
            <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

            <!-- CSS Reset -->
            <style type="text/css">
            /* What it does: Remove spaces around the email design added by some email clients. */
                  /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              height: 100% !important;
              width: 100% !important;
            }
            /* What it does: Stops email clients resizing small text. */
            * {
              -ms-text-size-adjust: 100%;
              -webkit-text-size-adjust: 100%;
            }
            /* What it does: Forces Outlook.com to display emails full width. */
            .ExternalClass {
              width: 100%;
            }
            /* What is does: Centers email on Android 4.4 */
            div[style*="margin: 16px 0"] {
              margin: 0 !important;
            }
            /* What it does: Stops Outlook from adding extra spacing to tables. */
            table, td {
              mso-table-lspace: 0pt !important;
              mso-table-rspace: 0pt !important;
            }
            /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
            table {
              border-spacing: 0 !important;
              border-collapse: collapse !important;
              table-layout: fixed !important;
              margin: 0 auto !important;
              margin-block-end: 5px;
              margin-block-start: 5px;
            }
            table table table {
              table-layout: auto;
            }
            /* What it does: Uses a better rendering method when resizing images in IE. */
            img {
              -ms-interpolation-mode: bicubic;
            }
            /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
            .yshortcuts a {
              border-bottom: none !important;
            }
            /* What it does: Another work-around for iOS meddling in triggered links. */
            a {
                    color: #AF0F2B;
                    text-decoration: underline;
                    font-weight: 700;
                  }

            .cabeza2{
              font-family: Arial,helvetica,sans-serif;
            font-style: italic;
            font-weight: 400;
            font-size: 22px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            }
            .unidad{
            font-family:  Arial,helvetica,sans-serif;
            font-weight: 800;
            font-size: 28px;
            line-height: 0px;
            text-align: center;
            color: #000000;
            padding-top:20px;
            padding-bottom: 5px;
            }
            .anio{
            font-family:  Arial,helvetica,sans-serif;
            font-weight: 800;
            font-size: 28px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            padding-top:20px;
            padding-bottom: 5px;
            }
            .folio{
            font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            }
            .mejor{
            font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 24px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            padding-top: 25px;
            padding-bottom: 2px;
            }
            .oferta{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 34px;
            line-height: 150%;
            align-items: center;
            text-align: center;
            color: #AF0F2B;
            }
            .div_naranja{
              background-color: #E63E19; 

            }
            .validez{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 150%;
            align-items: center;
            text-align: center;
            color: #696969;
            }
            .inspeccion{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 22px;
            line-height: 150.1%;
            align-items: center;
            text-align: center;
            color: #696969;
            }
            </style>

            <!-- Progressive Enhancements -->
            <style type="text/css">
            /* What it does: Hover styles for buttons */
            .button-td, .button-a {
              transition: all 100ms ease-in;
            }
            .button-td:hover, .button-a:hover {
              background: #A50932 !important;
              border-color: #A50932 !important;
            }

            /* Media Queries */
            @media screen and (max-width: 480px) {
            /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
            .fluid, .fluid-centered {
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              margin-left: auto !important;
              margin-right: auto !important;
            }
            /* And center justify these ones. */
            .fluid-centered {
              margin-left: auto !important;
              margin-right: auto !important;
            }
            /* What it does: Forces table cells into full-width rows. */
            .stack-column, .stack-column-center {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              direction: ltr !important;
            }
            /* And center justify these ones. */
            .stack-column-center {
              text-align: center !important;
            }
            /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
            .center-on-narrow {
              text-align: center !important;
              display: block !important;
              margin-left: auto !important;
              margin-right: auto !important;
              float: none !important;
            }
            table.center-on-narrow {
              display: inline-block !important;
            }
            }
            </style>
            </head>
            <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
            <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
              <tr>
                <td><center style="width: 100%;">
                    
                    <!-- Visually Hidden Preheader Text : BEGIN -->
                    <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Solicitud desde Vende tu auto </div>
                    <!-- Visually Hidden Preheader Text : END -->
                    
                    <div style="max-width: 600px;"> 
                      <!--[if (gte mso 9)|(IE)]>
                        <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                        <tr>
                        <td>
                        <![endif]--> 
                      
                      <!-- Email Header : BEGIN -->
                      <div style="width:100%">

                        <img style="max-width:100%" src="https://qa-vendetuauto.autocomseminuevos.com/imgs/head.jpg" alt="" bgcolor="#ffffff">
                      
                      </div>

                      <!-- Email Header : END --> 
                      
                      <!-- Email Body : BEGIN -->
                      <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 600px;">
                        
                      <!-- 1 Column Text : BEGIN -->
                        <tr>
                          <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                              <tr>
                                <td style="padding: 30px;padding-bottom:0px; text-align: center;"> 
                                
                                
                                <p class="cabeza2"style="font-family:Arial,Helvetica,sans-serif;font-size: 22px;line-height:150%">
                                  <span style="color:#696969; font-style: italic;font-weight: 800;line-height: 150%;">Se ha realizado una solicitud de reserva a domicilio con los siguientes datos:</span>
                                  <br><br>
                                  <b><span style="color:#000000">Cliente:</span></b> ${this.nombre}<br><br>
                                  <b><span style="color:#000000">No. Folio:</span></b> ${this.foliomail}<br><br>
                                  <b><span style="color:#000000">No. inspección agendada:</span></b> ${sessionStorage.getItem("idvaloration")}<br><br>
                                  <b><span style="color:#000000">Fecha Validez:</span></b> ${sessionStorage.getItem("idvaloration")}<br><br>
                                  <b><span style="color:#000000">Teléfono del cliente:</span></b> ${sessionStorage.getItem("fecha_validez")}<br><br>
                                  <b><span style="color:#000000">E-mail del cliente:</span></b> ${this.email}<br><br>
                                  <b><span style="color:#000000">Marca de la unidad:</span> </b>${this.marca}<br><br>
                                  <b><span style="color:#000000">Modelo de la unidad:</span> </b>${this.modelo}<br><br>
                                  <b><span style="color:#000000">Año de la unidad:</span> </b>${this.año}<br><br>
                                  <b><span style="color:#000000">Lugar:</span> </b>Domicilio<br><br>
                                  <b><span style="color:#000000">Dirección:</span> </b>${this.direccion}<br><br>
                                  <b><span style="color:#000000">Número del lead:</span> </b>${sessionStorage.getItem("IdCreatio")}
                                </p>
                                  </td>
                                  </tr>
                                  
                              <tr>
                                <td>
                                  
                                  
                                  <hr size="1px" color="#D9D9D9" width="90%">
                                        <p class="validez" style="padding-top:20px;padding-bottom:25px;text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969">
                                          Si necesitas ayuda comunicate a: <br><a href="mailto:atenciononline@autocom.mx" style="color:#AF0F2B">atenciononline@autocom.mx</a> o al tel: <a href="tel:8000220015" style="color:#AF0F2B">800 02 20015</a>
                                        </p>
                                </td>
                              </tr>
                            </table></td>
                        </tr>

                
                      <!--[if (gte mso 9)|(IE)]>
                        </td>
                        </tr>
                        </table>
                        <![endif]--> 
                    </div>
                  </center></td>
              </tr>
            </table>
            </body>
            </html>
          `};

      axios.post(this.serverNotificaciones + "/emailSend",mail, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
          'Content-Type': 'application/json',
        }, 
        }).then((response) => {
            console.log('Mail domicilio --->', response.status);
        }).catch(error => {
          // this.mensajeError = 'ENEMD';
          //   this.modalErrorConexion = true;
        this.snifferError(error.message, 'notificaciones');
        console.log('Existe un error en notificaciones ...', error.message);
        });
    },

    enviaWhats(){

      this.infoCliente = this.marca+" "+this.modelo+" "+this.año+" "+this.lugar;
      //console.log('Enviando WhatsApp --->',this.infoCliente);

      let body = {
          from: "MGc74a1535c4981448d75077f816409ceb",
          to: "pmrg-id_sucursal:"+sessionStorage.getItem("idAgencia"),
          //templateId: "HX1ada68ef6ba126b51d15533971462005",
          templateId: "HX4504d31faa5a3abf2df28f90a25c5457",
          parametros: "{'1': '"+this.nombre+"', '2': '"+this.idvaloration+"', '3': '"+this.formatPrice(this.formatValue(this.offer))+"', '4': '"+this.infoCliente+"'}"
      };

      //console.log('Body Twilio -->', body);

      axios.post(this.twillioservice + "/envia-whatsapp-plantilla",body
      ).then((response) => {
          console.log('Mensaje WhatsApp--->', response.status);
          console.log('PMRG OK');
          // clearTimeout(this.intervalos);
          // window.location.replace("/Inspeccion");
      }).catch(error => {
        //this.snifferError(error.message, 'twillio');
        console.log('Existe un error en twillio ...', error.message);
        //   this.mensajeError = 'ETEWA';
        // this.modalErrorConexion = true;
      });
    },


    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatValue(value) {
      let val = Math.round(value / 100) * 100;
      return val
    },

    opendWindow(){
      clearInterval(this.intervalos);
      window.location.replace('/');
      //console.log('1');
    },

    tiempoActivo(){
      this.intervalos = setInterval(() => {
        this.opendWindow();
      },3600000);
    },

  //Funciones Geolocalización
    async getUserLocation() {

      if(this.domicilio !== 'domicilio'){
        console.log('Cita en agencia');
          this.modalUbicacion = true;

          return new Promise((resolve, reject) => {
              navigator.geolocation.getCurrentPosition(
                  ({coords}) =>{

                      this.latitud = coords.latitude;
                      this.longitud = coords.longitude;

                      // this.latitud = 19.5867782;
                      // this.longitud = -102.4749794;
                      
                      this.agenciasFull();
                      this.geocodeAddress();

                  },
                  (err) => {
                      this.localidadSelect = '';
                      this.GeoLocal = false;
                      this.NoGeoLocal = true;
                      console.log('No geolocalizacion');
                      reject();
                  }
              )
          }
          )
      } else {
        console.log('Cita a Domicilio');
      }


    },

     async geocodeAddress(){

     const googleMapApi = await new Loader({
         apiKey: 'AIzaSyCLK9M0V30eFrsh7GQM76rfq2LrmCeGmig',
         libraries: ["places","geometry"]
       })

       this.google = await googleMapApi.load();

       this.google = window.google;
       this.initMap();
     },

      initMap(){
       console.log('Geolocalizacion');
       //this.variables = variable1+','+variable2;
      var latlng =  new google.maps.LatLng(this.latitud, this.longitud);

       var geocoder =  new google.maps.Geocoder();
       var ejecuta = this;
       geocoder.geocode({ 'latLng': latlng }, function (results, status) {
           if (status !== google.maps.GeocoderStatus.OK) {
               console.log('NO Geolocalización');
               ejecuta.noGeolocalizador();
           }

           if (status == google.maps.GeocoderStatus.OK) {
               console.log('Respuesta del CLI google');
               if (results[0]) 
                 {

                  console.log('Latitud y Longitud --->',ejecuta.latitud+' , '+ejecuta.longitud);

                  let minDist = -1;
                  let indiceAgencia = -1;
                  let estado = "";
                  let ciudad = "";
                  let address_components = results[0].address_components;

                  for(let i=0; i<ejecuta.fullagencias.length; i++){
                    let distancia = window.google.maps.geometry.spherical.computeDistanceBetween(new window.google.maps.LatLng({lat: Number(ejecuta.fullagencias[i].latitud), lng:Number(ejecuta.fullagencias[i].longitud)}),
                    new window.google.maps.LatLng({lat: ejecuta.latitud, lng:ejecuta.longitud}));
                    distancia=Number((distancia/1000).toFixed(2));
                    //console.log('Distancia -->',distancia);

                    if (minDist === -1 || distancia < minDist) {
                      minDist = distancia;
                      indiceAgencia = i;
                    }
                  }

                  for (var i = 0; i < address_components.length; i++) 
                     {
                        if (address_components[i].types[0] === "administrative_area_level_1" && address_components[i].types[1] === "political") {
                             estado = address_components[i].long_name;    
                         }

                         
                         if (address_components[i].types[0] === "locality" && address_components[i].types[1] === "political" ) {
                            ciudad = address_components[i].long_name;   
                          }

                     }

                  //console.log('distancia min -->',minDist);
                  //console.log('datos -->',estado,ejecuta.fullagencias[indiceAgencia].id,ejecuta.fullagencias[indiceAgencia].nombre,ejecuta.fullagencias[indiceAgencia].domicilio);

                  ejecuta.autoEdo(estado,ejecuta.fullagencias[indiceAgencia].nombre);

                }
                else 
                {
                   console.log('GEO No hay datos');
                   ejecuta.noGeolocalizador();
                }
           }
       });
     },

     agenciasFull(){
      axios
        .get( this.server + "/calendario/sucursales", {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {

          this.fullagencias = response.data.data;
          console.log('Carga agencias');
          //console.log('agencias full -->',this.fullagencias);

        })
        .catch((error) => {
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });

     },

    noGeolocalizador(){
      this.GeoLocal = false;
      this.NoGeoLocal = true;
    },

    siGeolocalizdor(){
      this.GeoLocal = true;
      this.NoGeoLocal = false;
    },

    autoEdo(estado,agencia){

      console.log('Info --->',estado+' - '+' - '+agencia);
        this.estadoGeo = estado;

      if(this.estadoGeo === 'Estado de México'){
        this.siGeolocalizdor();
        this.localidadSelect = 'Estado de México';
        this.asignaDatos(agencia);
      } else

      // if(this.estadoGeo === 'Ciudad de México'){
      //   this.localidadSelect = 'Estado de México';
      //   this.asignaMx();
      // } else

      if(this.estadoGeo === 'Querétaro'){
        this.siGeolocalizdor();
        this.localidadSelect = 'Querétaro';
        this.asignaDatos(agencia);
      } else

      if(this.estadoGeo === 'Guanajuato'){
        this.siGeolocalizdor();
        this.localidadSelect = 'Guanajuato';
        this.asignaDatos(agencia);
      } else

      if(this.estadoGeo === 'Michoacán'){
        this.siGeolocalizdor();
        this.localidadSelect = 'Michoacán';
        this.asignaDatos(agencia);
      } else 

      {
        console.log('Otro estado -->',this.estadoGeo);
        this.asignaSugerencia(agencia);
      }

    },

    asignaDatos(agencia){
      console.log('Asignando agencia -->',agencia);
      this.agenciasGeo();
      this.agenciaSelect = agencia;
      this.asignAgencia();
    },

    agenciasGeo(){

      //console.log('agenciasGeo -->',this.estadoGeo+' - '+this.localidadSelect);

      this.agenciaSelect = '';
      this.agendaSelect = '';
      this.horaActive = false;
      this.fechaSelect='';
      this.fechaSelected='';

      let body = {
        estado: this.localidadSelect,
      };

      axios
        .post( this.server + "/calendario/sucursales_estado", body, {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {

          this.agencias = response.data.data;

        })
        .catch((error) => {
          // this.mensajeError = 'EACOE';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });      
    },

    asignaSugerencia(agencia){
      console.log('Sugerencia  -->',agencia);

      this.agendaSelect = '';
      this.horaActive = false;

      let body = {
        nombre: agencia,
      };

      axios
        .post( this.server + "/calendario/sucursales_nombre", body, {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {

          this.sucursal = response.data.data;
          this.localidadSelect = response.data.data[0].estado;
          this.agenciasGeo();
          this.agenciaSelect = agencia;
          this.idagenciaGeo = response.data.data[0].id;
          this.nombreGeo = response.data.data[0].nombre;
          this.domicilioGeo = response.data.data[0].domicilio;
          this.siGeolocalizdor();
          this.changeToDate();

        })
        .catch((error) => {
          // this.mensajeError = 'EACOAG';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });      
    },

    asignAgencia(){
      //console.log('asignaAgencia -->',this.agenciaSelect);

      this.agendaSelect = '';
      let min=this.getMin();
      let _split=min.split('-');
      this.fechaSelected=_split[2]+'-'+_split[1]+'-'+_split[0];
      this.horaActive = false;
      this.fechaSelect=this.getMin();

      let body = {
        nombre: this.agenciaSelect,
      };

      axios
        .post( this.server + "/calendario/sucursales_nombre", body, {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {

          this.sucursal = response.data.data;
          //console.log('Datos sucursal -->',this.sucursal);
          this.idagenciaGeo = response.data.data[0].id;
          this.nombreGeo = response.data.data[0].nombre;
          this.domicilioGeo = response.data.data[0].domicilio;
          this.changeToDate();

        })
        .catch((error) => {
          // this.mensajeError = 'EACOAG';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });      
    },

    agendaGeo() {

      const date = new Date();
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');

      let _split=this.fechaSelected.split('-');
      this.fechaSelect=_split[2]+'-'+_split[1]+'-'+_split[0];

      console.log("FECHA SELECT", this.fechaSelect);
      console.log("OUTPUT", output)

      if (this.fechaSelect >= output) {
        this.fechaError = true;
        this.horaActive = true;

        let body = {
          fechaInicial: this.fechaSelect,
          fechaFinal: this.fechaSelect,
          idcalendario: 0,
          idsucursal: this.idagenciaGeo,
          idcliente: 0,
          idpmrg: 0,
          idcomprador: 0
        };

        //console.log('Body agenda -->',body);

        axios.post(this.server + "/calendario/consulta", body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Respuesta ---->", this.idagenciaGeo);
          if(Number(this.idagenciaGeo)===57){ //Pedregal
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=18 && _hora!==15 && _hora!==16){
                    return hora;
                  }
                }
                
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(this.idagenciaGeo)===58){ //Honda Universidad
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=17 && _hora!==15 && _hora!==16){
                    return hora;
                  }
                }
                
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(this.idagenciaGeo)===59){ //Hyundai Universidad
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===1 || _date.getDay()===3 || _date.getDay()===5){//Lunes, miércoles y viernes
                  if(_hora>=15 && _hora<=17){
                    return hora;
                  }
                }else if(_date.getDay()===2 || _date.getDay()===4 || _date.getDay()===6){//martes, jueves y sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(this.idagenciaGeo)===60){ //Toyota Universidad
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=12){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=17 && _hora!==14 && _hora!==15){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(this.idagenciaGeo)===61 ){ //Toyota revolucion
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=12){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=17){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else if(Number(this.idagenciaGeo)===62 || Number(this.idagenciaGeo)===63){ //Autocom Patriotismo, Autocom Revolucion
            const filter=response.data.data.filter(hora=>{
              if(hora.hora.indexOf(':30')<0){
                let _hora=Number(hora.hora.substr(0,2));
                const split=this.fechaSelect.split('-');
                const _date=new Date(`${split[1]}/${split[2]}/${split[0]}`);
                if(_date.getDay()===0){//Domingo
                  //No hay citas
                }else if(_date.getDay()===6){//Sábado
                  if(_hora>=9 && _hora<=13){
                    return hora;
                  }
                }else{
                  if(_hora>=9 && _hora<=18 && _hora!==14 && _hora!==15){
                    return hora;
                  }
                }
              }
            })
            this.horas = filter;
            this.horaVisual = true;
            this.fechaVisual = false;
          }else{
            this.horas = response.data.data;
            this.horaVisual = true;
            this.fechaVisual = false;
          }
        })
        .catch((error) => {
          // this.mensajeError = 'EACOCA';
          // this.modalErrorConexion = true;
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
        });
      } else {
        this.fechaError = false;
        this.horaActive = false;
      }
    },


    /** rechazos */
    getRechazo() {
      axios
        .get(this.server + "/causas_rechazo/listado", {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        })
        .then(({ data }) => {

          this.rechazos = data.data;
          //console.log('Respuesta --->',this.rechazos);
        })
        .catch((error) => {
          this.snifferError(error.message, 'AutoCheck');
          console.log('Existe un error en autocheck ...', error.message);
        });

    },
    getMotivos() {

      //console.log(this.rechazo[0]);

      axios
        .get(this.server + "/motivos_rechazo/search_ByCausa?rid_causa=2", {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        })
        .then(({ data }) => {

          this.motivos = data.data;
          //console.log('Respuesta --->', this.motivos);
        })
        .catch((error) => {
          this.snifferError(error.message, 'AutoCheck');
          console.log('Existe un error en autocheck ...', error.message);
        });
    },

    async cancelarSolicitud() {
      this.modalCancelacion = false;
      let body = {

        rid_valuacion: sessionStorage.getItem("idvaloration"),
        //dev
        rid_usuario: 170,
        rid_motivo: this.motivo[0],
        comentarios: 'Rechazo VA'
      };

      //console.log('Body -->',body);

      axios.post(this.server + "/rechazo_valuacion/create", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          this.enviaRechazo();
          //console.log(response);
          setTimeout(() => {
            this.$router.replace({ path: "/" });
          }, 150);
        })
        .catch((error) => {
          // this.show1 = false;
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.mensajeError1 = 'EVACV';
          this.modalCancelacion = false;
          this.snifferError(error.message, 'Rechazo');
          console.log('Error en el servicio de valoraciones ...', error.message);
        });
    },

    enviaRechazo() {

      this.ofertamail = this.formatPrice(sessionStorage.getItem("oferta"));
      this.foliomail = sessionStorage.getItem("idvaloration");
      this.idvaloration = sessionStorage.getItem("idvaloration");

      let mail = {
        user: "vendetuauto@autocom.mx",
        aplication: "Vende tu Auto",
        subject: "AUTOCOM OFERTA RECHAZADA",
        EmailsTo: [{ email: this.emailM }],
        EmailsToCc: [{ emailCc: "noreply@autocom.mx" },
        { emailCc: "" }],
        body: `
           <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
            <html>
            <head>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
            <!-- utf-8 works for most cases -->
            <meta name="viewport" content="width=device-width">
            <!-- Forcing initial-scale shouldn't be necessary -->
            <meta http-equiv="X-UA-Compatible" content="IE=edge">
            <!-- Use the latest (edge) version of IE rendering engine -->
            <title>Oferta VTA generico</title>
              <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
            <!-- The title tag shows in email notifications, like Android 4.4. -->

            <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
            <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

            <!-- CSS Reset -->
            <style type="text/css">
            /* What it does: Remove spaces around the email design added by some email clients. */
                  /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              height: 100% !important;
              width: 100% !important;
            }
            /* What it does: Stops email clients resizing small text. */
            * {
              -ms-text-size-adjust: 100%;
              -webkit-text-size-adjust: 100%;
            }
            /* What it does: Forces Outlook.com to display emails full width. */
            .ExternalClass {
              width: 100%;
            }
            /* What is does: Centers email on Android 4.4 */
            div[style*="margin: 16px 0"] {
              margin: 0 !important;
            }
            /* What it does: Stops Outlook from adding extra spacing to tables. */
            table, td {
              mso-table-lspace: 0pt !important;
              mso-table-rspace: 0pt !important;
            }
            /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
            table {
              border-spacing: 0 !important;
              border-collapse: collapse !important;
              table-layout: fixed !important;
              margin: 0 auto !important;
              margin-block-end: 5px;
              margin-block-start: 5px;
            }
            table table table {
              table-layout: auto;
            }
            /* What it does: Uses a better rendering method when resizing images in IE. */
            img {
              -ms-interpolation-mode: bicubic;
            }
            /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
            .yshortcuts a {
              border-bottom: none !important;
            }
            /* What it does: Another work-around for iOS meddling in triggered links. */
            a {
                    color: #AF0F2B;
                    text-decoration: underline;
                    font-weight: 700;
                  }

            .cabeza2{
              font-family: Arial,helvetica,sans-serif;
            font-style: italic;
            font-weight: 800;
            font-size: 22px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            }
            .unidad{
            font-family:  Arial,helvetica,sans-serif;
            font-weight: 800;
            font-size: 28px;
            line-height: 0px;
            text-align: center;
            color: #000000;
            padding-top:20px;
            padding-bottom: 5px;
            }
            .anio{
            font-family:  Arial,helvetica,sans-serif;
            font-weight: 800;
            font-size: 28px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            padding-top:20px;
            padding-bottom: 5px;
            }
            .folio{
            font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            }
            .mejor{
            font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 24px;
            line-height: 150%;
            text-align: center;
            color: #696969;
            padding-top: 25px;
            padding-bottom: 2px;
            }
            .oferta{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 34px;
            line-height: 150%;
            align-items: center;
            text-align: center;
            color: #AF0F2B;
            }
            .div_naranja{
              background-color: #E63E19;

            }
            .validez{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 150%;
            align-items: center;
            text-align: center;
            color: #696969;
            }
            .inspeccion{
              font-family:  Arial,helvetica,sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: 22px;
            line-height: 150.1%;
            align-items: center;
            text-align: center;
            color: #696969;
            }
            </style>

            <!-- Progressive Enhancements -->
            <style type="text/css">
            /* What it does: Hover styles for buttons */
            .button-td, .button-a {
              transition: all 100ms ease-in;
            }
            .button-td:hover, .button-a:hover {
              background: #A50932 !important;
              border-color: #A50932 !important;
            }

            /* Media Queries */
            @media screen and (max-width: 480px) {
            /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
            .fluid, .fluid-centered {
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              margin-left: auto !important;
              margin-right: auto !important;
            }
            /* And center justify these ones. */
            .fluid-centered {
              margin-left: auto !important;
              margin-right: auto !important;
            }
            /* What it does: Forces table cells into full-width rows. */
            .stack-column, .stack-column-center {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              direction: ltr !important;
            }
            /* And center justify these ones. */
            .stack-column-center {
              text-align: center !important;
            }
            /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
            .center-on-narrow {
              text-align: center !important;
              display: block !important;
              margin-left: auto !important;
              margin-right: auto !important;
              float: none !important;
            }
            table.center-on-narrow {
              display: inline-block !important;
            }
            }
            </style>
            </head>
            <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
            <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
              <tr>
                <td><center style="width: 100%;">

                    <!-- Visually Hidden Preheader Text : BEGIN -->
                    <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Esta es tu oferta AUTOCOM </div>
                    <!-- Visually Hidden Preheader Text : END -->

                    <div style="max-width: 600px;">
                      <!--[if (gte mso 9)|(IE)]>
                        <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                        <tr>
                        <td>
                        <![endif]-->

                      <!-- Email Header : BEGIN -->
                      <div style="width:100%">

                        <img style="max-width:100%" src="https://qa-vendetuauto.autocomseminuevos.com/img/mail/head3.jpg" alt="" bgcolor="#ffffff">

                      </div>

                      <!-- Email Header : END -->

                      <!-- Email Body : BEGIN -->
                      <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 600px;">

                      <!-- 1 Column Text : BEGIN -->
                        <tr>
                          <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                              <tr>
                                <td style="padding: 30px;padding-bottom:0px; text-align: center;">

                                <h1>
                                  <span style="font-family:Arial,Helvetica,sans-serif; font-weight: 800; font-size: 34px; line-height: 150%; text-align: center; color: #AF0F2B; padding-bottom: 5px;">HOLA ${this.nombre.toUpperCase()}</span>
                                </h1>
                                <p class="cabeza2"style="font-family:Arial,Helvetica,sans-serif;font-size: 22px;line-height:150%">
                                  <span style="color:#696969; font-style: italic;font-weight: 800;line-height: 150%;">Haz decidido no aceptar la oferta que tenemos para ti</span>
                                  <br>
                                  <span class="unidad"style="font-family:Arial,Helvetica,sans-serif;font-size: 28px;color:#000000;line-height:150%"><b><span class="anio"style="color: #696969">${this.año} </span>${this.marca} ${this.modelo} </b></span>
                                  <br>
                                  <span class="folio"style="font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969;line-height: 150%;">NO. DE OFERTA: ${this.foliomail}</span>
                                </p>
                                  <p class="mejor" style="margin-block-end: 0px;font-family:Arial,Helvetica,sans-serif;font-size: 20px;color: #696969">EL RANGO DE TU<BR>MEJOR OFERTA <b><span style="color:#000000">GARANTIZADA</span></b> ES<br>
                                    <span class="oferta"style="font-family:Arial,Helvetica,sans-serif; margin-block-start: 5px;margin-block-end:5px;font-size: 34px;color:#AF0F2B;text-align: center">DE <B>$ ${this.formatPrice(this.formatValue(this.ofertaMin))}*</B><br>A <B>$ ${this.formatPrice(this.formatValue(this.ofertaMax))}*</B></span>
                                    <span class="validez" style="text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969"><br>
                                    Esta oferta es válida hasta el <b>${this.validezVA}</b><br>
                                    *El monto final de la oferta depende de la inspección del vehículo
                                  </span>
                                </p>
                                  </td>
                                  </tr>
                              <tr>
                                <td>
                                  <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;font-size: 22px;color: #696969" class="inspeccion"><b>La oferta estará disponible para ti, si decides retomarla <a href="https://${this.iframe}/Oferta?vafolio=${this.idvaloration}&seguimiento=creatio" style="color:#AF0F2B">haz clic aquí</a></b>
                                  </p>
                                  <hr size="1px" color="#D9D9D9" width="90%">
                                        <p class="validez" style="padding-top:20px;padding-bottom:25px;text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969">
                                          Si necesitas ayuda comunicate a: <br><a href="mailto:atenciononline@autocom.mx" style="color:#AF0F2B">atenciononline@autocom.mx</a> o al tel: <a href="tel:8000220015" style="color:#AF0F2B">800 02 20015</a>
                                        </p>
                                </td>
                              </tr>
                            </table></td>
                        </tr>
                      <!--[if (gte mso 9)|(IE)]>
                        </td>
                        </tr>
                        </table>
                        <![endif]--> 
                    </div>
                  </center></td>
              </tr>
            </table>
            </body>
            </html>
           `};

      axios.post(this.serverNotificaciones + "/emailSend", mail, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        console.log('Mail rechazo--->', response.status);
      }).catch(error => {
        console.log('Algo salio mal mail --->', error.message);
        this.snifferError(error.message, 'Notificaciones');
      });
    },

  },

  watch: {
     codigoPostal() {
       this.checkFormDomicilio();
     },
     estado() {
       this.checkFormDomicilio();
     },
     ciudad() {
       this.checkFormDomicilio();
     },
     colonia() {
       this.checkFormDomicilio();
     },
     calle() {
       this.checkFormDomicilio();
     },
     noExterior() {
       this.checkFormDomicilio();
     }
  },
  computed: {
    kmComputedString() {
      let kmString = this.kilometraje.toString()
      let string_size = kmString.length;
      let kmArray = [];
      if (string_size % 3 == 0) {
        for (let i = 0; i < string_size / 3; i++)
          kmArray[i] = kmString.substr(i * 3, 3);
      } else if (string_size % 3 == 1) {
        kmArray[0] = kmString[0]
        kmString = kmString.substr(1);
        for (let i = 0; i < (string_size / 3) - 1; i++)
          kmArray[i + 1] = kmString.substr(i * 3, 3);
      } else {
        kmArray[0] = kmString.substr(0, 2)
        kmString = kmString.substr(2);
        for (let i = 0; i < (string_size / 3) - 1; i++)
          kmArray[i + 1] = kmString.substr(i * 3, 3);
      }
      let kmFinalString = "";
      kmArray.forEach(element => kmFinalString += element + ',');
      return kmFinalString.slice(0, kmFinalString.length - 1);
    }
  },

  created() {
    this.getUserLocation();
    this.cargarToken();
    this.cargarTokenMail();
    //this.tokenCreatio();
    this.dateCreatio();
    this.getEstados();
    this.tiempoActivo();
    this.getRechazo();
    this.getMotivos();
  },
  
  onMounted(){
    window.scrollTo(0, 0)
  }

};
</script>

<style>
.marcaModelo {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 33px;
  color: #51555C;
  margin-bottom: 20px;
}

.lamentamos {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #51555C;
}

.marcaModelo {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 33px;
  color: #51555C;
  margin-bottom: 20px;
}

.motivoTextSelect {
  padding: 0 15%;
  text-align: left;
  width: 100%;
}

.motivoCancelacion {
  display: block;
  margin-top: 35px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  align-items: left;
  color: #51555C;
}

.motivoTextSelect select {
  display: block;
}

.buttonsCancel {
  margin-top: 50px !important;
}
</style>